var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"trailer",staticClass:"trailer",style:(`background-image: url('${_vm.media.trailer.thumbnail}')`),on:{"click":_vm.showTrailer}},[_c('icon',{staticClass:"icon",attrs:{"name":"play-circle","width":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }